import { initContract } from '@ts-rest/core';
import { GroupReportRequestSchema, NewGroupBooking } from '../types/zod/groupBooking';
import { z } from 'zod';

const c = initContract();

export const groupBookingContract = c.router({
  findAll: {
    method: 'GET',
    path: `/group-booking`,
    responses: { 200: c.type<NewGroupBooking[]>() },
  },
  findById: {
    method: 'GET',
    path: `/group-booking/:groupBookingId`,
    pathParams: z.object({
      groupBookingId: z.string(),
    }),
    responses: { 200: c.type<NewGroupBooking>() },
  },
  generateReport: {
    method: 'POST',
    path: `/property/:propertyId/group-booking-report/export`,
    pathParams: z.object({
      propertyId: z.string(),
    }),
    query: z.object({
      approvedOnly: z.string(),
      from: z.string(),
      to: z.string(),
    }),
    headers: z.object({
      authorization: z.string(),
    }),
    body: z.array(GroupReportRequestSchema),
    responses: { 200: z.string() },
  },
});
